import { createFileRoute, redirect } from '@tanstack/react-router';

import { getUserConversionState } from '../_ensure-version.index/-utils';
import { channelsOwnerAccessQueryOptions } from '../../../api/channels';

export const Route = createFileRoute('/_authenticated/onboarding/_ensure-version/auto-determine-flow/')({
  component: () => <div></div>,
  loader: async ({ context: { authContextProvider, serviceEnvironment, queryClient } }) => {
    const { hasCreatedSources } = await getUserConversionState();

    if (!hasCreatedSources) {
      console.info('User is new to SE.Live, redirecting to new-setup');
      return redirect({
        to: '/onboarding/new-setup',
      });
    }

    const channelsAccess = await queryClient.ensureQueryData(
      channelsOwnerAccessQueryOptions({
        authContextProvider,
        serviceEnvironment,
      })
    );

    if (channelsAccess.length <= 1) {
      console.info('User has created sources and scenes, redirecting to setup-multistreaming');
      return redirect({
        to: '/onboarding/setup-multistreaming',
      });
    }

    console.info('User has created sources and scenes, redirecting to onboarding index');

    return redirect({
      to: '/onboarding',
    });
  },
});
